// src/components/CapabilityCard.js
import React from 'react';
// Icon component is passed as a prop, no need to import all possibilities here

function CapabilityCard({ category, skills, Icon }) {
  // Basic validation in case Icon is not passed correctly
  const IconComponent = Icon || (() => null); // Default to null component if Icon is missing

  return (
    <div className="mt-10 bg-white rounded-xl shadow-lg overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-xl p-6 flex flex-col items-center text-center h-full">
      <div className="bg-indigo-100 text-indigo-600 rounded-full p-4 mb-4 inline-block">
        <IconComponent size={32} strokeWidth={1.5} />
      </div>
      <h3 className="text-xl font-semibold text-gray-800 mb-2">{category}</h3>
      {/* Ensure skills is an array before mapping */}
      {Array.isArray(skills) && (
         <ul className="text-gray-600 text-sm list-none p-0">
            {skills.map((skill, index) => (
             <li key={index} className="mt-1">{skill}</li>
            ))}
         </ul>
      )}
    </div>
  );
}

export default CapabilityCard;
